import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR, NETWORK_LOGIN_LOGIN_USER, NETWORK_LOGIN_SUCCESS,
} from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
  login_user_data: {},
  network_login_user: {},
};

const Login = (state = initialState, action) => {
  switch (action.type) {
    case NETWORK_LOGIN_LOGIN_USER:
    {
      state = {
        ...state,
        loading: true,
      };
      console.log('========= Hello World')
      break;
    }
    case NETWORK_LOGIN_SUCCESS:
    {
      state = {
        ...state,
        loading: false,
        network_login_user: action.payload
      };
      break;
    }
    case LOGIN_USER: 
    {
      state = {
        ...state,
        loading: true,
      };
      console.log('========= Hello World')
      break;
    }
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        login_user_data: action.payload
      };
      break;
    case LOGOUT_USER:
      state = { ...state };
      break;
    case LOGOUT_USER_SUCCESS:
      state = { ...state };
      break;
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default Login;
